import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Debug, Button, SubmitButton, MobileCardItem, Typography, Grid, Divider, makeStyles } from "../../../../";
import "@material-ui/styles";
import "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
var useStyles = makeStyles(function (theme) {
  return {
    my12: {
      margin: "12px 0"
    },
    my24: {
      margin: "24px 0"
    },
    mt8: {
      marginTop: "8px"
    },
    mb8: {
      marginBottom: "8px"
    },
    containerFlexNoWrap: {
      display: "flex",
      flexFlow: "row nowrap"
    },
    containerFlexWrap: {
      display: "flex",
      flexFlow: "row wrap",
      alignItems: "center"
    },
    containerContent: {
      padding: "12px 0"
    },
    chipGroup: {
      border: "1px solid ".concat(theme.palette.text.primary),
      borderRadius: "8px",
      background: theme.palette.background.paper,
      margin: "4px"
    },
    linkIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "inherit"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    flexGrow: {
      flex: "1"
    },
    editIcon: {
      color: "#ffe082"
    },
    actions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    pl8: {
      paddingLeft: "8px"
    },
    pr8: {
      paddingRight: "8px"
    },
    textFlexWidth: {
      flexGrow: "1",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    textAnimation7s: {
      display: "inline-block",
      animation: "$animate 7s linear 2s alternate infinite"
    },
    "@keyframes animate": {
      "0%": {
        transform: "translateX(0%)"
      },
      "25%": {
        transform: "translateX(0%)"
      },
      "75%": {
        transform: "translateX(-80%)"
      },
      "100%": {
        transform: "translateX(-80%)"
      }
    },
    attendanceStatus: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "space-between",
      "min-height": "145px",
      "align-items": "start"
    }
  };
});

var MobileCampusProfileTabChildren = function MobileCampusProfileTabChildren(props) {
  // console.log("props tab children", props);
  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      typeView = _useState2[0],
      setTypeView = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      childSelected = _useState4[0],
      setChildSelected = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      serviceSelected = _useState6[0],
      setServiceSelected = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      responsibleSelected = _useState8[0],
      setResponsibleSelected = _useState8[1];

  var classes = useStyles();

  var handleEditUser = function handleEditUser(key, serviceId) {
    setChildSelected(props.data.children.find(function (child) {
      return child.key === key;
    }));
    setServiceSelected(props.data.children.find(function (child) {
      return child.key === key;
    }).services.find(function (service) {
      return service.serviceId === serviceId;
    }));
    setTypeView("edit_user");
  };

  var handleEditResponsible = function handleEditResponsible(key, serviceId, idResponsible) {
    setChildSelected(props.data.children.find(function (child) {
      return child.key === key;
    }));
    setServiceSelected(props.data.children.find(function (child) {
      return child.key === key;
    }).services.find(function (service) {
      return service.serviceId === serviceId;
    }));
    setResponsibleSelected(props.data.children.find(function (child) {
      return child.key === key;
    }).services.find(function (service) {
      return service.serviceId === serviceId;
    }).extraResponsibles.find(function (extraResponsible) {
      return extraResponsible._id === idResponsible;
    }));
    setTypeView("edit_responsible");
  };

  var handleAddResponsible = function handleAddResponsible(key, serviceId) {
    setChildSelected(props.data.children.find(function (child) {
      return child.key === key;
    }));
    setServiceSelected(props.data.children.find(function (child) {
      return child.key === key;
    }).services.find(function (service) {
      return service.serviceId === serviceId;
    }));
    setTypeView("add_responsible");
  };

  var createContentTypeView = function createContentTypeView() {
    var content;

    switch (typeView) {
      case "view":
        content = props.data.children.map(function (child) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: classes.my12
          }, child.name), child.services.map(function (service) {
            return /*#__PURE__*/React.createElement(MobileCardItem, {
              template: "profileChildrenListParent",
              data: _objectSpread(_objectSpread({}, service), {}, {
                handleEditUser: handleEditUser,
                handleEditResponsible: handleEditResponsible,
                handleAddResponsible: handleAddResponsible
              }),
              classes: classes.my12,
              translation: props.translation ? props.translation.card_item : null
            });
          }));
        });
        break;

      case "edit_user":
        if (childSelected && serviceSelected) {
          var initialValuesUser = {
            allergies: serviceSelected.allergies,
            comments: serviceSelected.comments,
            status: serviceSelected.status
          };
          var userSchema = Yup.object().shape({
            allergies: Yup.string().nullable(),
            comments: Yup.string().nullable(),
            status: Yup.string().matches(/yes|injured/).required()
          });
          content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1"
          }, childSelected.name), /*#__PURE__*/React.createElement(Formik, {
            initialValues: initialValuesUser,
            validationSchema: userSchema,
            onSubmit: function onSubmit(values) {
              var changes = {
                information: true,
                extraResponsibles: false
              }; // console.log("service", serviceSelected);

              props.data.handleSubmitEditChild(_objectSpread(_objectSpread({}, values), {}, {
                changes: changes,
                key: childSelected.key,
                service: "Campus",
                serviceId: serviceSelected.serviceId
              }));
              setChildSelected(null);
              setServiceSelected(null);
              setTypeView("view");
            },
            render: function render(_ref) {
              var values = _ref.values,
                  isValid = _ref.isValid,
                  isSubmitting = _ref.isSubmitting,
                  setFieldValue = _ref.setFieldValue;
              return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
                container: true,
                spacing: 2
              }, /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.mt8
              }, /*#__PURE__*/React.createElement(Field, {
                component: TextField,
                label: props.translation ? props.translation.inputs ? props.translation.inputs.allergies || "Allergies" : "Allergies" : "Allergies",
                name: "allergies",
                variant: "outlined",
                fullWidth: true,
                margin: "normal"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.mt8
              }, /*#__PURE__*/React.createElement(Field, {
                component: TextField,
                label: props.translation ? props.translation.inputs ? props.translation.inputs.comments || "Comments" : "Comments" : "Comments",
                name: "comments",
                variant: "outlined",
                fullWidth: true,
                margin: "normal"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: [classes.mt8, classes.attendanceStatus].join(" ")
              }, /*#__PURE__*/React.createElement(Typography, {
                variant: "body1"
              }, props.translation && props.translation.card_item ? props.translation.card_item.labels ? props.translation.card_item.labels.status ? props.translation.card_item.labels.status || "Attendance" : "Attendance" : "Attendance" : "Attendance"), /*#__PURE__*/React.createElement(Button, {
                variant: values.status === "yes" ? "contained" : "outlined",
                color: "primary",
                fullWidth: true,
                onClick: function onClick() {
                  setFieldValue("status", "yes");
                }
              }, props.translation ? props.translation.buttons ? props.translation.buttons.status ? props.translation.buttons.status.yes || "Assist" : "Assist" : "Assist" : "Assist"), /*#__PURE__*/React.createElement(Button, {
                variant: values.status === "injured" ? "contained" : "outlined",
                fullWidth: true,
                color: "secondary",
                onClick: function onClick() {
                  // console.log("cambiando value a injured");
                  setFieldValue("status", "injured");
                }
              }, props.translation ? props.translation.buttons ? props.translation.buttons.status ? props.translation.buttons.status.injured || "Injured" : "Injured" : "Injured" : "Injured")), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.actions
              }, /*#__PURE__*/React.createElement(Button, {
                type: "button",
                size: "medium",
                className: classes.mr30,
                color: "secondary",
                variant: "outlined",
                onClick: function onClick() {
                  setTypeView("view");
                }
              }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
                size: "medium",
                color: "primary",
                variant: "outlined",
                disabled: !isValid || isSubmitting,
                component: SubmitButton,
                type: "submit"
              }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save"))), /*#__PURE__*/React.createElement(Grid, {
                container: true
              }));
            }
          }));
        } else {
          content = "";
        }

        break;

      case "add_responsible":
        var initialValuesExtraResponsible = {
          name: "",
          phone: "" // status: "",

        };
        var extraResponsibleSchema = Yup.object().shape({
          name: Yup.string().required(),
          phone: Yup.string().required() // status: Yup.string()
          //   .matches(/authorized|not_authorized/)
          //   .required(),

        });
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, childSelected.name), /*#__PURE__*/React.createElement(Formik, {
          initialValues: initialValuesExtraResponsible,
          validationSchema: extraResponsibleSchema,
          onSubmit: function onSubmit(values) {
            var changes = {
              information: false,
              extraResponsibles: true
            };
            props.data.handleSubmitAddChildExtraResponsible({
              extraResponsible: _objectSpread({}, values),
              changes: changes,
              key: childSelected.key,
              service: "Campus",
              serviceId: serviceSelected.serviceId
            });
            setTypeView("view");
            setChildSelected(null);
            setServiceSelected(null);
          },
          render: function render(_ref2) {
            var values = _ref2.values,
                isValid = _ref2.isValid,
                isSubmitting = _ref2.isSubmitting,
                setFieldValue = _ref2.setFieldValue;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.responsible.inputs ? props.translation.responsible.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.mt8
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.responsible.inputs ? props.translation.responsible.inputs.phone || "Phone" : "Phone" : "Phone",
              name: "phone",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setTypeView("view");
              }
            }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.submit || "Save" : "Save" : "Save"))), /*#__PURE__*/React.createElement(Grid, {
              container: true
            }));
          }
        }));
        break;

      case "edit_responsible":
        if (childSelected && serviceSelected && responsibleSelected) {
          var _initialValuesExtraResponsible = {
            name: responsibleSelected.name,
            phone: responsibleSelected.phone,
            status: responsibleSelected.status
          };

          var _extraResponsibleSchema = Yup.object().shape({
            name: Yup.string().required(),
            phone: Yup.string().required(),
            status: Yup.string().matches(/authorized|not_authorized/).required()
          });

          content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1"
          }, childSelected.name), /*#__PURE__*/React.createElement(Formik, {
            initialValues: _initialValuesExtraResponsible,
            validationSchema: _extraResponsibleSchema,
            onSubmit: function onSubmit(values) {
              var changes = {
                information: false,
                extraResponsibles: true
              };
              props.data.handleSubmitEditChildExtraResponsible({
                extraResponsible: _objectSpread(_objectSpread({}, values), {}, {
                  _id: responsibleSelected._id
                }),
                changes: changes,
                key: childSelected.key,
                service: "Campus",
                serviceId: serviceSelected.serviceId
              });
              setTypeView("view");
              setChildSelected(null);
              setServiceSelected(null);
              setResponsibleSelected(null);
            },
            render: function render(_ref3) {
              var values = _ref3.values,
                  isValid = _ref3.isValid,
                  isSubmitting = _ref3.isSubmitting,
                  setFieldValue = _ref3.setFieldValue;
              return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
                container: true,
                spacing: 2
              }, /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.mt8
              }, /*#__PURE__*/React.createElement(Field, {
                component: TextField,
                label: props.translation ? props.translation.responsible.inputs ? props.translation.responsible.inputs.name || "Name" : "Name" : "Name",
                name: "name",
                variant: "outlined",
                fullWidth: true,
                margin: "normal"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.mt8
              }, /*#__PURE__*/React.createElement(Field, {
                component: TextField,
                label: props.translation ? props.translation.responsible.inputs ? props.translation.responsible.inputs.phone || "Phone" : "Phone" : "Phone",
                name: "phone",
                variant: "outlined",
                fullWidth: true,
                margin: "normal"
              })), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: [classes.mt8, classes.actions].join(" ")
              }, /*#__PURE__*/React.createElement(Button, {
                variant: values.status === "authorized" ? "contained" : "outlined",
                color: "primary",
                onClick: function onClick() {
                  setFieldValue("status", "authorized");
                }
              }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.status ? props.translation.responsible.buttons.status.authorized || "Authorized" : "Authorized" : "Authorized" : "Authorized"), /*#__PURE__*/React.createElement(Button, {
                variant: values.status === "not_authorized" ? "contained" : "outlined",
                color: "secondary",
                onClick: function onClick() {
                  setFieldValue("status", "not_authorized");
                }
              }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.status ? props.translation.responsible.buttons.status.not_authorized || "Not authorized" : "Not authorized" : "Not authorized" : "Not authorized")), /*#__PURE__*/React.createElement(Grid, {
                item: true,
                xs: 12,
                className: classes.actions
              }, /*#__PURE__*/React.createElement(Button, {
                type: "button",
                size: "medium",
                className: classes.mr30,
                color: "secondary",
                variant: "outlined",
                onClick: function onClick() {
                  setTypeView("view");
                }
              }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
                size: "medium",
                color: "primary",
                variant: "outlined",
                disabled: !isValid || isSubmitting,
                component: SubmitButton,
                type: "submit"
              }, props.translation ? props.translation.responsible.buttons ? props.translation.responsible.buttons.submit || "Save" : "Save" : "Save"))));
            }
          }));
        } else {
          content = "";
        }

        break;

      default:
        break;
    }

    return content;
  };

  return createContentTypeView();
};

export { MobileCampusProfileTabChildren };